export const STATS = {
    // Home page
    all: {
        anchors: 130,
        borrowers: 17603,
        invoices: 300921,
        disbursed: 22909993000,
        aum: 3125122000,
    },
    // SaralPay Later
    bnpl: {
        anchors: 21,
        borrowers: 4270,
        invoices: 27161,
        disbursed: 8085787000,
        aum: 458753000,
    },
    // Vendor Finance
    vendor: {
        anchors: 7,
        borrowers: 83,
        invoices: 774,
        disbursed: 5431307000,
        aum: 874445000,
    },
    // Supplychain finance
    scf: {
        anchors: 19,
        borrowers: 133,
        invoices: 834,
        disbursed: 9392899000,
        aum: 1791924000,
    },
};
